import * as rtk from "@reduxjs/toolkit";
const { createAction, createSlice } = { ...rtk }.default || rtk;
const modalStateName = "global-modal";
const modalSlice = createSlice({
  name: modalStateName,
  initialState: {
    visibleModal: null,
    activeModals: {}
  },
  reducers: {},
  extraReducers(builder) {
    builder.addCase(openModalAction, (state, { payload }) => {
      state.activeModals[payload.id] = payload;
      state.visibleModal = findVisibleModal(state.activeModals);
    }).addCase(closeModalAction, (state, { payload }) => {
      delete state.activeModals[payload.id];
      state.visibleModal = findVisibleModal(state.activeModals);
    });
  }
});
const openModalAction = createAction("crystal/openModal");
const closeModalAction = createAction("crystal/closeModal");
const { reducer: modalReducer } = modalSlice;
function findVisibleModal(activeModals) {
  const modals = Object.values(activeModals);
  if (!modals.length) {
    return null;
  }
  return modals.reduce((top, curr) => curr.zIndex < top.zIndex ? curr : top, modals[0]);
}
export {
  closeModalAction,
  modalReducer,
  modalStateName,
  openModalAction
};
//# sourceMappingURL=modal.js.map
